export function saveInProgressPollResponse(
  pollSessionId: string,
  draftResponse: string | number[],
) {
  window.flightLogger.log(
    `Saving in-progress poll response for poll session ${pollSessionId} response=${draftResponse}`,
  );
  const _inProgressPollResponses = JSON.parse(
    localStorage.getItem("poll-responses-in-progress") || "{}",
  );
  localStorage.setItem(
    "poll-responses-in-progress",
    JSON.stringify({
      ..._inProgressPollResponses,
      [pollSessionId]: draftResponse,
    }),
  );
}

export function deleteInProgressPollResponse(pollSessionId: string) {
  window.flightLogger.log(`Deleting in-progress poll response for poll session ${pollSessionId}`);
  const _inProgressPollResponses = JSON.parse(
    localStorage.getItem("poll-responses-in-progress") || "{}",
  );
  delete _inProgressPollResponses[pollSessionId];
  localStorage.setItem("poll-responses-in-progress", JSON.stringify(_inProgressPollResponses));
}
